<template>
	<v-container fluid>
		<div class="d-flex flex-wrap py-2">
			<v-btn class="ma-1" color="primary" small to="/autofacturas">
				<v-icon left>mdi-arrow-left</v-icon>Volver a facturas
			</v-btn>
			<v-btn class="ma-1" color="primary" small @click="getContratos">
				<v-icon left>mdi-reload</v-icon>Recargar
			</v-btn>

			<v-switch
				class="mt-0 ml-1 align-self-center"
				label="Mostrar no facturables"
				hide-details
				v-model="mostrarNoFacturables"
			></v-switch>

			<v-spacer></v-spacer>

			<v-btn
				:disabled="selected.length == 0 || selected.some(c => c.IBAN == null)"
				class="ma-1"
				color="secondary"
				small
				:loading="generandoAutofactura"
				@click="generarAutofacturaLote"
			>
				<v-icon left>mdi-cash-register</v-icon>Generar autofacturas
			</v-btn>
		</div>
		<v-card>
			<v-data-table
				fixed-header
				:items="contratosFiltrados"
				:headers="contratosHeader"
				:calculate-widths="true"
				:loading="loading"
				:footer-props="{
					showFirstLastPage: true,
					showCurrentPage: true,
					itemsPerPageOptions: [10, 25, 50],
				}"
				checkbox-color="secondary"
				:single-select="false"
				show-select
				item-key="canal"
				v-model="selected"
			>
				<template v-slot:body.prepend="{ headers }">
					<table-filters :headers="headers" :items="contratosFiltrados" v-model="inlineFilters"></table-filters>
				</template>

				<template v-slot:item.NDevoluciones="{ item }">
					<span class="error--text">{{ item.NDevoluciones || '0' }}</span>
				</template>
				<template v-slot:item.importe="{ item }">
					<span class="font-weight-bold" v-text="parseFloat(item.importe).toFixed(2) + ' €'" />
				</template>
				<template v-slot:item.importeDevoluciones="{ item }">
					<span
						class="error--text font-weight-bold"
						v-text="parseFloat(item.importeDevoluciones).toFixed(2) + ' €'"
					/>
				</template>
				<!-- <template v-slot:item.NCom="{ item }">
					<span class="error--text">{{ item.NCom || '0' }}</span>
				</template>
				<template v-slot:item.ImporteCom="{ item }">
					<span class="error--text">{{ item.ImporteCom || '0' }}</span>
				</template>-->

				<template v-slot:item.baseImponible="{ item }">
					<v-chip label>{{ parseFloat(item.baseImponible * 1 || 0).toFixed(2) }} €</v-chip>
				</template>

				<template v-slot:item.acciones="{ item }">
					<div class="d-flex align-center justify-end">
						<v-btn v-if="item.IBAN"
							@click="colaborador = item.canal"
							outlined
							color="secondary"
							icon
						>
							<v-icon>mdi-cash-register</v-icon>
						</v-btn>
						<v-alert class="mb-0 ml-2" dense type="info" text v-if="!item.facturable">Nos faltan datos del colaborador</v-alert>
					</div>
				</template>
			</v-data-table>
		</v-card>

		<v-bottom-sheet
			scrollable
			:value="colaborador"
			@input="(v) => v === false ? (() => { colaborador = false; lineas = [] })() : null"
		>
			<v-card>
				<v-toolbar color="primary">
					<v-toolbar-title class="white--text">GENERAR FACTURA {{ colaborador }}</v-toolbar-title>
					<v-spacer />
					<v-btn icon @click="colaborador = false">
						<v-icon color="white">mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<v-card-text class="pa-3" style="max-height: 700px;">
					<v-container fluid>
						<v-form ref="formulario_autofactura">
							<v-row>
								<v-col cols="6">
									<v-text-field
										v-model="autofactura.nDoc"
										:rules="[rules.req]"
										dense
										hide-details="auto"
										filled
										label="Nº Documento"
										readonly
									></v-text-field>
								</v-col>
								<v-col cols="6">
									<v-text-field
										v-model="fechaFormateada"
										:rules="[rules.req]"
										dense
										hide-details="auto"
										filled
										label="Fecha"
										readonly
										append-icon="mdi-calendar"
									></v-text-field>
								</v-col>
							</v-row>
						</v-form>

						<v-subheader>Contratos a facturar</v-subheader>

						<v-card>
							<v-data-table
								fixed-header
								:items="lineas"
								:headers="lineasHeader"
								item-key="CodigoContrato"
								:calculate-widths="true"
								:loading="loading"
								:footer-props="{
									showFirstLastPage: true,
									showCurrentPage: true,
									itemsPerPageOptions: [10, 25, 50],
								}"
							>
								<template v-slot:body.prepend="{ headers }">
									<table-filters :headers="headers" :items="lineas" v-model="inlineFilters2"></table-filters>
								</template>

								<template v-slot:item.Situacion="{ item }">
									<div class="d-flex align-center">
										<status-chip
											:value="Number(item.incidencia) && item.estado != 'Anulado' ? 'Incidencia' : item.Situacion"
										/>
										<v-alert
											class="mb-0 ml-2"
											dense
											type="info"
											text
											v-if="!Number(item.aDevolver) && item.Situacion == 'Baja'"
										>Aún no ha sido facturado</v-alert>
									</div>
								</template>

								<template v-slot:item.CodigoContrato="{ item }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												v-on="on"
												v-bind="attrs"
												link
												:to="`/detalles_contrato?codigoContrato=${item.CodigoContrato}&idContrato=${item.IdContrato}`"
												:color="Number(item.aDevolver) ? 'error' : 'secondary'"
												text
											>{{ item.CodigoContrato }}</v-btn>
										</template>
										<span>Detalles del contrato</span>
									</v-tooltip>
								</template>

								<template v-slot:item.Identificador="{ item }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												v-on="on"
												v-bind="attrs"
												link
												:to="`/detalles_cliente?idCliente=${item.IdCliente}`"
												:color="Number(item.aDevolver) ? 'error' : 'secondary'"
												text
											>{{ item.Identificador }}</v-btn>
										</template>
										<span>Detalles del cliente</span>
									</v-tooltip>
								</template>

								<template v-slot:item.CodigoCUPS="{ item }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												v-on="on"
												v-bind="attrs"
												link
												:to="`/detalles_cups?cups=${item.CodigoCUPS}`"
												:color="Number(item.aDevolver) ? 'error' : 'secondary'"
												text
											>{{ item.CodigoCUPS }}</v-btn>
										</template>
										<span>Detalles del CUPS</span>
									</v-tooltip>
								</template>

								<template v-slot:item.FechaContrato="{ item }">
									<span v-text="parseDate(item.FechaContrato)" />
								</template>
								<template v-slot:item.FechaAlta="{ item }">
									<span v-text="parseDate(item.FechaAlta)" />
								</template>
								<template v-slot:item.FechaBaja="{ item }">
									<span v-text="parseDate(item.FechaBaja)" />
								</template>

								<template v-slot:item.comision="{ item }">
									<v-chip label>{{ item.comision * 1 }} €</v-chip>
								</template>

								<template v-slot:item.aDevolver="{ item }">
									<span
										:class="[!Number(item.aDevolver) || 'error--text']"
									>{{ Number(item.aDevolver) ? 'Sí' : 'No' }}</span>
								</template>
							</v-data-table>
						</v-card>

						<v-card-actions class="align-center">
							<v-alert
								class="mb-0"
								text
								v-if="repetido"
								dense
								type="error"
							>Ya existe una factura con este nombre</v-alert>
							<v-spacer />
							<v-btn @click.stop="generarAutofactura" large text color="primary">Generar</v-btn>
						</v-card-actions>
					</v-container>
				</v-card-text>
			</v-card>
		</v-bottom-sheet>
	</v-container>
</template>

<script>
import { perColumnFilter, parseDate, timeAgo } from '@/utils/index.js';
import { req } from '@/utils/validations.js';

export default {
	components: {
		TableFilters: () => import('@/components/TableFilters.vue'),
		StatusChip: () => import('@/components/StatusChip.vue')
	},
	data() {
		return {
			p: {
				show: false,
				resolve: null,
				reject: null,
			},
			contratos: [],
			lineas: [],
			loading: false,
			repetido: false,
			selected: [],
			rules: { req },
			lineasHeader: [
				{ text: 'Situacion', value: 'Situacion', dataType: 'select' },
				// { text: 'IdAgente', value: 'IdAgente', },
				{ text: 'Contrato', value: 'CodigoContrato' },
				// { text: 'Fecha Contrato', value: 'FechaContrato', dataType: 'date' },
				{ text: 'Fecha Alta', value: 'FechaAlta', dataType: 'date' },
				{ text: 'Fecha Baja', value: 'FechaBaja', dataType: 'date' },
				{ text: 'Meses Activado', value: 'Diferencia' },
				{ text: 'CUPS', value: 'CodigoCUPS' },
				{ text: 'Cliente', value: 'Identificador' },
				{ text: 'Nombre Cliente', value: 'Denominacion' },
				{ text: 'Base Imponible', value: 'comision' },
				{ text: 'Devolución', value: 'aDevolver' },
				// { text: 'A DEVOLVER', value: 'aDevolver' },

			].map((header) => {
				return {
					class: "text-no-wrap sticky-header",
					cellClass: "pa-2 text-no-wrap",
					filter: (value) =>
						perColumnFilter(
							value,
							this.inlineFilters2[header.value],
							header.dataType
						),
					dataType: "text",
					...header,
				};
			}),
			contratosHeader: [
				{ text: 'Colaborador', value: 'canal' },
				{ text: 'Nº Contratos', value: 'NContratos' },
				{ text: 'Importe', value: 'importe' },
				{ text: 'Nº Dev', value: 'NDevoluciones' },
				{ text: 'Importe Dev', value: 'importeDevoluciones' },
				// { text: 'Nº COM', value: 'NCom' },
				// { text: 'Importe Com', value: 'ImporteCom' },
				{ text: 'Base imponible', value: 'baseImponible' },
				{ text: 'Acciones', value: 'acciones', filterable: false, sortable: false, align: 'center' },

			].map((header) => {
				return {
					class: "text-no-wrap sticky-header",
					cellClass: "pa-2 text-no-wrap",
					filter: (value) =>
						perColumnFilter(
							value,
							this.inlineFilters[header.value],
							header.dataType
						),
					dataType: "text",
					...header,
				};
			}),
			inlineFilters: {},
			inlineFilters2: {},
			colaborador: null,
			autofactura: {
				fecha: [new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()].join('-'),
				nDoc: null,
				showDate: false
			},
			generandoAutofactura: false,

			mostrarNoFacturables: false,
		}
	},
	computed: {
		fechaFormateada() {
			return parseDate(this.autofactura.fecha)
		},
		contratosFiltrados() {
			return this.mostrarNoFacturables ? this.contratos : this.contratos.filter(c => c.facturable)
		}
	},
	mounted() {
		this.getContratos();
	},
	methods: {
		parseDate,
		timeAgo,
		getContratos() {
			this.loading = true;
			this.selected = [];

			axios({
				method: "GET",
				url: `${process.env.VUE_APP_OUR_API_URL}/autofacturar.php`,
				params: { token: this.$store.getters.getJwtEmpresa }
			}).then((res) => {
				this.contratos = res.data.map(c => {
					c.facturable = [c.IBAN, c.porcentajeIva, c.porcentajeIrpf, c.direccion, c.cp, c.ciudad, c.provincia, c.cif].every(f => !!f)
					return c;
				})
				this.loading = false;
			});
		},
		async generarAutofactura() {
			if (!this.$refs.formulario_autofactura.validate()) return;

			axios({
				method: 'POST',
				url: `${process.env.VUE_APP_OUR_API_URL}/autofacturar.php`,
				data: {
					canal: [this.colaborador],
					fecha: new Date(this.autofactura.fecha).getTime(),
					token: this.$store.getters.getJwtEmpresa,
				}
			}).then(res => {
				this.colaborador = null;
				this.$root.$emit('snack', 'Autofactura generada correctamente')
				this.getContratos();
			})
		},
		async generarAutofacturaLote() {
			try {
				this.generandoAutofactura = true;
				await axios({
					method: 'POST',
					url: `${process.env.VUE_APP_OUR_API_URL}/autofacturar.php`,
					data: {
						canal: this.selected.map(f => f.canal),
						fecha: new Date(this.autofactura.fecha).getTime(),
						token: this.$store.getters.getJwtEmpresa,
					}
				})
				this.generandoAutofactura = false;
				this.$root.$emit('snack', 'Autofacturas generadas correctamente')
				this.$router.push({ name: 'Autofacturas' })
			} catch (e) {
				this.generandoAutofactura = false;
				this.p.show = false;
				this.$root.$emit('snack', 'Ha ocurrido un error al generar las autofacturas')
			}

			return

		}
	},
	watch: {
		async colaborador(n) {
			if (n) {
				this.loading = true;
				const { data } = await axios({
					method: 'GET',
					url: `${process.env.VUE_APP_OUR_API_URL}/autofacturar.php`,
					params: {
						canal: this.colaborador,
						token: this.$store.getters.getJwtEmpresa
					}
				})

				this.lineas = data.lineas.map(l => ({
					...l, Denominacion:
						l.RazonSocialTitular ||
						[l.NombreTitular, l.Apellido1Titular, l.Apellido2Titular]
							.filter((i) => !!i)
							.join(" "),
				}));

				if (data.ultimoNombre) {

					let [num, year] = data.ultimoNombre.split('/')

					if (new Date().getFullYear() != year) num = 0;

					this.autofactura.nDoc = [('0000' + (Number(num) + 1)).slice(-4), new Date().getFullYear()].join('/');
				} else {
					this.autofactura.nDoc = `0001/${new Date().getFullYear()}`;
				}
			}
			this.loading = false;
		}
	}
}
</script>

<style scoped>
.v-data-table /deep/ [role="columnheader"] {
	/* background: #f1f1f1 !important; */
}

.v-data-table /deep/ [role="columnheader"] {
	/* background: #f1f1f1 !important; */
}
.triangle {
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;

	border-top: 10px solid white;
	margin: 0 auto;
}
